import axios from '../plugins/axios'

export default {
  scroll({ token, device, os, event_type, date_from, date_to, selected_visit_type }){
      return axios.get('/api/v1/heatmaps/show/' + token + ".json", { params: {
        device: device,
        os: os,
        event_type: event_type,
        date_from: date_from,
        date_to: date_to,
        selected_visit_type: selected_visit_type,
      }
    })
  },
  click({ token, device, os, event_type, date_from, date_to, selected_visit_type}){
    return axios.get('/api/v1/heatmaps/show/click/' + token + ".json", { params: {
        device: device,
        os: os,
        event_type: event_type,
        date_from: date_from,
        date_to: date_to,
        selected_visit_type: selected_visit_type,
      }
    })
  },
  attention({ token, device, os, event_type, date_from, date_to, selected_visit_type}){
      return axios.get('/api/v1/heatmaps/show/attention/' + token + ".json", { params: {
        device: device,
        os: os,
        event_type: event_type,
        date_from: date_from,
        date_to: date_to,
        selected_visit_type: selected_visit_type,
      }
    })
  },
  toggleShared(token){
    return axios.post('/api/v1/heatmaps/toggle_shared/' + token + ".json")
  },
  sharedStatus(token){
    return axios.get('/api/v1/heatmaps/shared_status/' + token + ".json")
  },
  deleteDesign({token, design_id}){
    return axios.post('/api/v1/heatmaps/delete_web_design/' + token + ".json",
      {
        design_id: design_id
      }
    )
  },
  clickLinkLogs({ heatmap_id, from, to }){
    return axios.get('/api/v1/heatmap_click_link_logs', {
      params: {
        heatmap_id: heatmap_id,
        from: from,
        to: to
      }
    })
  }
}
